import {
  require_jsx_runtime
} from "./chunk-TLC4E3UP.js";
import "./chunk-JATAHO7O.js";
export default require_jsx_runtime();
//# sourceMappingURL=react_jsx-runtime.js.map
